<template>
  <div class="c-searchDropdown" v-if="options">
    <!-- Dropdown Input -->
    <input
      class="c-searchDropdown__input"
      :name="name"
      @click="showOptions()"
      @keyup="keyMonitor"
      @mouseover="inputMouseovered = true"
      @mouseleave="inputMouseovered = false"
      @focus="inputFocused = true"
      @blur="inputFocused = false"
      v-model="searchFilter"
      :disabled="disabled"
      :placeholder="placeholder"
      autocomplete="off"
    />

    <!-- Dropdown Menu -->
    <div
      class="c-searchDropdown__content"
      v-show="optionsShown"
      @mouseover="contentMouseovered = true"
      @mouseleave="contentMouseovered = false"
    >
      <div
        class="c-searchDropdown__item"
        @click="selectOption(option)"
        v-for="(option, index) in filteredOptions"
        :key="index"
      >
        <div
          :style="{
            color:
              addInputColors !== undefined &&
              addInputColors.includes(option.name)
                ? `red`
                : '',
          }"
        >
          {{ option.name || option.id || "-" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  template: "Dropdown",
  props: {
    name: {
      type: String,
      required: false,
      default: "dropdown",
      note: "Input name",
    },
    options: {
      type: Array,
      required: true,
      note: "Options of dropdown. An array of options with id and name",
    },
    placeholder: {
      type: String,
      required: false,
      default: "Please select an option",
      note: "Placeholder of dropdown",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: "Disable the dropdown",
    },
    maxItem: {
      type: Number,
      required: false,
      default: 9999,
      note: "Max items showing",
    },
    defaultSelectedOptionFromName: {
      type: String,
      required: false,
      default: "",
      note: "set selected option from name",
    },
    defaultSelectedOptionFromNameHandler: {
      type: Boolean,
      required: false,
      default: false,
      note: "set selected option from name",
    },
    addInputColors: {
      type: Array,
      required: false,
      default: undefined,
      note: "set selected option from name",
    },
  },
  data() {
    return {
      selected: {},
      currentOption: {},
      optionsShown: false,
      searchFilter: "",
      firstRender: true,
      contentMouseovered: false,
      inputMouseovered: false,
      inputFocused: false,
    };
  },
  created() {
    this.$emit("selected", this.selected);
  },
  mounted() {
    this.setDefaultSelectedOptionFromName();

    document.addEventListener("click", () => {
      if (
        this.optionsShown &&
        !this.contentMouseovered &&
        !this.inputMouseovered
      ) {
        this.optionsShown = false;
        this.searchFilter = this.currentOption.name;
      }
    });
  },
  computed: {
    filteredOptions() {
      if (this.searchFilter.length === undefined) return;
      const filtered = [];
      const regOption = new RegExp(this.searchFilter, "ig");
      for (const option of this.options) {
        if (this.searchFilter.length < 1 || option.name.match(regOption)) {
          if (filtered.length < this.maxItem) filtered.push(option);
        }
      }
      return filtered;
    },
  },
  methods: {
    setDefaultSelectedOptionFromName() {
      if (this.defaultSelectedOptionFromName !== "") {
        const setOption = this.options.filter(
          value => value.name === this.defaultSelectedOptionFromName,
        );
        this.selectOption(setOption[0]);
      } else {
        this.resetOption();
      }
    },
    selectOption(option) {
      this.selected = option;
      this.currentOption = option;
      this.optionsShown = false;
      this.searchFilter = this.selected.name;
      this.$emit("selected", this.selected);
    },
    resetOption() {
      this.selected = {};
      this.currentOption = {};
      this.optionsShown = false;
      this.searchFilter = "";
    },
    showOptions() {
      if (!this.disabled) {
        this.searchFilter = "";
        this.optionsShown = true;
      }
    },
    // Selecting when pressing Enter
    keyMonitor: function(event) {
      if (event.key === "Enter" && this.filteredOptions[0])
        this.selectOption(this.filteredOptions[0]);
    },
  },
  watch: {
    defaultSelectedOptionFromNameHandler(newVal) {
      console.log(newVal, this.defaultSelectedOptionFromName);
      if (newVal) this.setDefaultSelectedOptionFromName();
    },
    searchFilter() {
      if (this.filteredOptions.length === 0) {
        this.selected = {};
      } else {
        this.selected = this.filteredOptions[0];
      }

      if (
        this.inputFocused &&
        this.searchFilter == "" &&
        this.optionsShown == false
      ) {
        this.optionsShown = true;
      }
      this.$emit("filter", this.searchFilter);
    },
    options(option) {
      if (!this.firstRender) return;
      this.selectOption(option[0]);
      this.firstRender = false;
    },
  },
};
</script>
